<template>
    <div class="my-8 flex flex-col px-8 py-4 text-xl border-l-8 border-gray-400 text-gray-700 font-semibold no-last-margin"
         v-html="block.Text"></div>
</template>

<script>
    export default {
        name: "HighlightedText",
        data() {
            return {
                block: {
                    Text: 'This text will stand out because it is styled.'
                }
            }
        }
    };
</script>